import { create } from "zustand";
import { createProjectSlice } from "./slices/projectFileTreeSlice";
import { createAuthSlice } from "./slices/authSlice";
import { createAlertSlice } from "./slices/alertSlice";
import { createNotificationSlice } from "./slices/notificationSlice";

export const useAppStore = create((set, get) => ({
  ...createAuthSlice(set, get),
  ...createProjectSlice(set, get),
  ...createAlertSlice(set, get),
  ...createNotificationSlice(set, get),
}));
